import React, { Component } from 'react';
import { getRequestHistory } from '../utils/CityApiUtils';
import { getHumanReadableDate } from '../utils/globalUtils';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import CircularProgress from '@material-ui/core/CircularProgress';

class CityRequestTimeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    this.fetchHistory();
  }

  componentDidUpdate(prevProps) {
    if (this.props.requestId !== prevProps.requestId && this.props.open) {
      this.fetchHistory();
    }
  }

  fetchHistory = () => {
    const { requestId } = this.props;
    if (!requestId) return;

    this.setState({ loading: true, error: null });
    getRequestHistory(requestId)
      .then(response => {
        if (response.status === 'success') {
          this.setState({ history: response.data, loading: false });
        } else {
          this.setState({ error: response.message, loading: false });
        }
      })
      .catch(err => {
        this.setState({ error: 'Failed to load history', loading: false });
      });
  };

  renderContent() {
    const { history, loading, error } = this.state;

    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
          <CircularProgress />
        </div>
      );
    }

    if (error) {
      return <Typography color="error">{error}</Typography>;
    }

    if (history.length === 0) {
      return <Typography>No history available.</Typography>;
    }

    return (
      <Stepper orientation="vertical">
        {history.map((item, index) => {
          const { status_value, created_at, comments, metadata, performer } = item;
          // Note: Assuming comments contains remarks and performed_by_role
          // changed_by is the user ID. In a real app we might want to map this to a name 
          // either by fetching user details or if the API returns it.
          // For now showing Role and Remarks.
          
          let role = comments && comments.performed_by_role ? comments.performed_by_role : 'Unknown Role';
          let remarks = comments && comments.remarks ? comments.remarks : '';
          
          let label = '';
          switch(status_value) {
            case 'created':
              label = 'Request Created';
              break;
            case 'edited':
              label = 'Request Edited';
              break;
            case 'approved':
              label = 'Request Approved';
              break;
            case 'rejected':
              label = 'Request Rejected';
              break;
            default:
              label = `Status: ${status_value}`;
          }

          return (
            <Step key={index} active={true}>
              <StepLabel>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                  {label}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {getHumanReadableDate(created_at)} by {performer ? performer.name : 'Unknown'} ({role ? role.toUpperCase() : 'Unknown'})
                </Typography>
              </StepLabel>
              <StepContent>
                {remarks && (
                  <Typography variant="body2" style={{ marginTop: '5px' }}>
                    <strong>Remarks:</strong> {remarks}
                  </Typography>
                )}
                {metadata && metadata.before && (
                  <div style={{ marginTop: '10px', background: '#f5f5f5', padding: '10px' }}>
                    <Typography variant="caption" display="block">Previous Values:</Typography>
                    <Typography variant="body2">
                      City: {metadata.before.city_name || 'N/A'}, Bank Account Number: {metadata.before.bank_account_number || 'N/A'}
                    </Typography>
                  </div>
                )}
                {metadata && metadata.after && (
                  <div style={{ marginTop: '10px', background: '#f5f5f5', padding: '10px' }}>
                    <Typography variant="caption" display="block">New Values:</Typography>
                    <Typography variant="body2">
                      City: {metadata.after.city_name}, Bank Account Number: {metadata.after.bank_account_number}
                    </Typography>
                  </div>
                )}
              </StepContent>
            </Step>
          );
        })}
      </Stepper>
    );
  }

  render() {
    const { open, onClose } = this.props;

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>Request Timeline</DialogTitle>
        <DialogContent>
          {this.renderContent()}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CityRequestTimeline;



// WEBPACK FOOTER //
// ./src/components/CityRequestTimeline.js